import { WORKFLOW_DIFF_BLACKLIST_KEYS } from 'shared/schema/constants.js';

const filterWorkflowDiffs = (diffs) => {
  return diffs.filter((n) => {
    return typeof n?.key === 'string' && !WORKFLOW_DIFF_BLACKLIST_KEYS.some((key) => n.key.startsWith(key));
  });
};

export default filterWorkflowDiffs;
